/**
 * Converts a hex color string to an rgba string.
 * @param hex - Hex color string in the format #RRGGBB or #RRGGBBAA
 * @param alpha - Alpha value between 0 (transparent) and 1 (opaque)
 * @returns Rgba color string
 */
export function hexToRgba(hex: string, alpha: number): string {
  if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(hex)) {
    return "rgba(0,0,0,0)";
  }
  hex = hex.replace("#", "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("");
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
